export const MAX_VIDEO_DURATION_SEC = 180; // 3 minutes
